import React from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { ConfigProvider } from 'antd'
import 'dayjs/locale/ja'
import antdLocale from 'antd/lib/locale/ja_JP'
import 'moment/locale/ja'
import 'antd/dist/antd.less'
import '../styles/globals.css'
import Consts from '../configs/consts'
import { Provider } from 'mobx-react'
import { initStores } from '../stores'
import { setUnauthorizedErrorHandler, setForbiddenErrorHandler } from '../libs/fetch'

import '../styles/components/mdEditor.css'

const locale = { ...antdLocale }
function MyApp({ Component, pageProps, appProps }) {
  const router = useRouter()
  const stores = initStores(appProps.context)

  // アクセストークンの有効期限切れの共通処理
  setUnauthorizedErrorHandler(async () => {
    if (router.pathname.indexOf('/login') === -1) {
      stores.AuthStore.logout(true)
      await router.replace('/login')
    }
  })

  // アクセスが拒否されたの共通処理
  setForbiddenErrorHandler(async () => {
    if (router.pathname.indexOf('/login') === -1) {
      await router.replace('/403')
    }
  })

  return (
    <>
      <Head>
        <title>{Consts.ServiceName}</title>
      </Head>
      <Provider {...stores}>
        <ConfigProvider locale={locale}>
          <Component {...pageProps} />
        </ConfigProvider>
      </Provider>
    </>
  )
}

MyApp.getInitialProps = ({ ctx }) => {
  if (typeof window === 'undefined') {
    return { appProps: { context: { req: { headers: { cookie: ctx?.req?.headers?.cookie } } } } }
  } else {
    return { appProps: {} }
  }
}

export default MyApp
